// extracted by mini-css-extract-plugin
export var closeButton = "_13-1";
export var container = "_13-0";
export var fullModalImage = "_13-2";